import React from 'react';
import { FolderType } from 'types/sequences';
import 'twin.macro';
import { FDPIcon } from 'containers/Sequences/icons/FDPIcon';
import { SequenceIcon } from 'containers/Sequences/icons/SequenceIcon';
import { FolderIcon } from 'containers/Sequences/icons/FolderIcon';

interface Props {
  type: FolderType;
  className?: string;
}

export function FolderSequenceIcon(props: Props): React.ReactElement {
  const { type, className } = props;
  switch (type) {
    case 'fdp':
      return <FDPIcon className={className} />;
    case 'fdp_standalone':
      return <FDPIcon className={className} />;
    case 'sequence':
      return <SequenceIcon className={className} />;
    case 'folder':
      return <FolderIcon className={className} />;
  }
}
